import React, {useContext, useState} from 'react';
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import EditOrgWithDaData from "../../../../components/Modals/EditOrgWithDaData";
import OrgPage from "../../../../components/OrgPage";
import DaDataModal3 from "../../../../components/Modals/DaDataModal3";
import {AuthContext} from "../../../../context/AuthContext";

function MedCenters_medcenter(props) {
    const {REACT_APP_URL_PREFIX} = process.env
    const {token} = useContext(AuthContext)
    const url = `/api/v2/systemManagers/${token.userId}/medCenters?`

    const baseURL = process.env.REACT_APP_BASE_URL
    const [modal, showModal] = useState()
    const [editModal, showEditModal] = useState()
    const [modalId, setModalId] = useState()
    const [refresh, setRefresh] = useState(false)

    const editOrg = (   data) => {
        setModalId(data)
        showEditModal(true)
    }

    const closeHandler = () => {
        showModal(false)
        showEditModal(false)
        setRefresh(!refresh)
    }


    const linkCell = props => {
        const url = REACT_APP_URL_PREFIX + `/counterAgents/medCenters/${props.idArr[0]}/${props.cellContent}/${props.idArr[1]}/organizations`
        return <LinkCell3 linkRoute={url}
                          linkTitle={props.cellContent}
                          editClick={_ => editOrg(props.idArr[0])}/>
    }


    return (
        <>
            {editModal && <EditOrgWithDaData id={modalId} closeHandler={closeHandler} url={"/api/v1/verificationCenter/medicalCenters?"}/>}
            {modal && <DaDataModal3 closeHandler={closeHandler} role={4}/>}

            <OrgPage
                refresh={refresh}
                firstRow={[
                    {title: 'Название', id: 'name'},
                    {title: 'Количество людей', id: ''},       // Сортировка не добавлена
                    {title: 'Количество организаций', id: ''}, // Сортировка не добавлена
                    {title: 'Вызов', id: ''},                  // Сортировка не добавлена
                ]}
                haveToShow={
                    [
                        {id: 'name', idArr: ['id', "verification_id"], type: 'wrapperCell', typeData: {cell: linkCell}},
                        {id: 'patients_count'},
                        {id: 'org_count'},
                        {id: 'invite_count'},
                    ]}
                url={`${baseURL}${url}`}

                breadCrumbsItems={[
                    {title: 'Контрагенты'},
                    {title: 'Мед. Центры', actual: true},
                ]}

                addOrg={{
                    med: true,
                    onClick() {
                        showModal(!modal)
                    }
                }}

                filterBarButtons={{
                    downloadTemplate: {
                        show: false,
                        url: '/'
                    }
                }}
                filterFieldsConf={{
                    name: true,
                    inn: true,
                    period: true,
                    date: true
                }}
            />
        </>
    );
}

export default MedCenters_medcenter;

